export const capitalizeFirstLetter = (word) => {
  const capitalized = word[0].toUpperCase() + word.slice(1, word.length);
  return capitalized;
};
